import { Box, Grid, useMediaQuery } from '@material-ui/core'
import { Background, NavBar, SideBar } from 'components'
import { MENU_IDS } from 'config/constants/navigation-menu'
import { theme } from 'config/constants/theme/theme'
import { useServiceState } from 'helpers'
import { MainMobileLayout } from 'layout/mainMobile'
import { get } from 'lodash'
import React from 'react'
import { Toolbar } from 'smart-components'
import { InitiativesSelectorDialog } from 'smart-components/initiatives-selector-dialog'
import { UserResponsesProvider } from 'smart-components/user-responses-manager'
import UserResponsesManagerService from 'smart-components/user-responses-manager/Service'
import { IProps } from './Interface'
import { useStyles } from './Styles'

const MainLayout: React.FC<IProps> = ({
  children,
  responses,
  validation,
  disabled,
  publicMode,
  user,
  hideMenuItem,
  pages
}) => {
  const userResponseManagerState = useServiceState(UserResponsesManagerService, false)

  const total = validation?.total || get(userResponseManagerState, 'userResponses.validation.total', {})
  const isLoadedResponses = !userResponseManagerState.isLoadingResponses
  const classes = useStyles({})
  const mobileView = useMediaQuery(theme.breakpoints.down('md'))

  const showWarningIcons = {
    [MENU_IDS.TOP_FIVES]: isLoadedResponses && !total.isTop5SComplete,
    [MENU_IDS.DID_YOU_KNOW]: (isLoadedResponses && !total.isDidYouKnowSemiComplete) || !total.isDidYouKnowComplete,
    [MENU_IDS.BASICS]: isLoadedResponses && !total.isTheBasicsComplete,
    [MENU_IDS.I_PURSUE_WITH_INTENSITY]: isLoadedResponses && !total.isIPursuitComplete,
    [MENU_IDS.IM_GOOD_AT]: isLoadedResponses && !total.isImGoodAtComplete,
    [MENU_IDS.MORE_ABOUT_ME]: isLoadedResponses && !total.isMoreAboutMeComplete
  }

  const disableMenuItem = {
    [MENU_IDS.SNAPSHOT]: !total.isComplete && !total.isMiniProfileComplete
  }

  return (
    <Grid container className={classes.root}>
      <Background />
      <div hidden={mobileView}>
        <SideBar disableMenuItem={disableMenuItem} />
      </div>
      {!publicMode && <InitiativesSelectorDialog />}
      {mobileView ? (
        <MainMobileLayout
          disabled={disabled}
          responses={responses}
          validation={validation}
          user={user}
          hideMenuItem={hideMenuItem}
          pages={pages}
        />
      ) : (
        <div className={classes.content}>
          <NavBar
            showWarningIcons={showWarningIcons}
            disableMenuItem={disableMenuItem}
            publicMode={publicMode}
            hideMenuItem={hideMenuItem}
          />
          <Box display="flex">
            {children}
            <Box ml={1} hidden={mobileView}>
              <Toolbar user={user} validation={validation} publicMode={publicMode} />
            </Box>
          </Box>
        </div>
      )}
    </Grid>
  )
}

MainLayout.defaultProps = {
  hideMenuItem: {}
}

export default (props: IProps) => (
  <UserResponsesProvider>
    <MainLayout {...props}>{props.children}</MainLayout>
  </UserResponsesProvider>
)
